// VisionHeroSection.jsx
import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";

// Replace these with your actual images
import eyeImage from "assets/images/wavelight/eye-detail.png"; // right image
import eyebg from "assets/images/wavelight/eyebg.png"; // right image
import { BookAppointmentButton } from "components";

const stats = [
  { value: "98%", label: "Achieved 20/20 Vision Or Better" },
  { value: "83%", label: "Achieved 20/16 Vision Or Better" },
  { value: "99%", label: "Would Recommend To Friends/Family" },
];

const VisionHeroSection = () => {
  return (
    <Box component="section" sx={{ width: "100%", overflow: "hidden" }}>
      {/* TOP STATS BAR */}
      <Box
        sx={{
          width: "100%",
          background: "#000",
          color: "#fff",
          py: { md: 3, xs: 2 },
          px: { md: 12, xs: 3 },
        }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          {stats.map((s, idx) => (
            <Grid
              key={idx}
              item
              xs={12}
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { md: "center", xs: "flex-start" },
                borderRight: idx < stats.length - 1 ? "1px solid rgba(255,255,255,0.12)" : "none",
                px: { md: 2, xs: 0 },
                py: { xs: 1, md: 0 },
              }}
            >
              <Box sx={{ textAlign: { md: "center", xs: "left" } }}>
                <Typography sx={{ fontSize: { md: "48px", xs: "36px" }, fontWeight: 700 }}>
                  {s.value}
                </Typography>
                <Typography sx={{ fontSize: { md: "14px", xs: "12px" }, mt: 1, opacity: 0.95 }}>
                  {s.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* HERO WITH GRADIENT + CONTENT */}
      <Box
        sx={{
          width: "100%",
         backgroundImage: `url(${eyebg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          py: { md: 12, xs: 8 },
          px: { md: 12, xs: 3 },
        }}
      >
        {/* dotted accents (optional) */}
       
      

        <Grid container spacing={4} alignItems="center" justifyContent="space-between">
          {/* LEFT TEXT */}
          <Grid item xs={12} md={6}>
            <Box sx={{ maxWidth: 680 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#6b6b6b", mb: 1 }}>
                EXPERIENCE STUNNING VISION
              </Typography>

              <Typography sx={{ fontSize: { md: "32px", xs: "22px" }, fontWeight: 800, mb: 2 }}>
                RIGHT FROM DAY 1
              </Typography>

              <Typography sx={{ color: "#5b5b5b", lineHeight: 1.8, mb: 3 }}>
                Step back into your world with freedom from glasses in just 24 hours.<br></br>
                Enjoy sharper vision, embrace every moment, and get back to work, play,<br></br>
                and life without waiting — clear, confident, and carefree.
              </Typography>

              <BookAppointmentButton />
            </Box>
          </Grid>

          {/* RIGHT IMAGE */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: { md: "flex-end", xs: "center" },
                px: { xs: 0, md: 2 },
              }}
            >
              <Box
                
              >
                <Box
                  component="img"
                  src={eyeImage}
                  alt="Eye"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "12px",
                    display: "block",
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default VisionHeroSection;
